import SimpleLightbox from "simplelightbox";

export function lightbox() {
    //var lightbox = $('.v-galerie__liste--item a');
    let $lightbox = new SimpleLightbox('.l-singleActivity__galerie a');
    $lightbox.on('show.simplelightbox', function () {
        // do something…
    });
}

lightbox();
